export function writeText(content) {
  return window.navigator.clipboard.writeText(content)
}
